export const uk = {
    'button-text': 'Все объявления с видеодополнениями'
};
